var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section h-100"},[_c('admin-section-header',{attrs:{"icon":"chat","title":"My Chat"}}),_c('SectionUnderDevelopment')],1)}
var staticRenderFns = []

export { render, staticRenderFns }